import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { User } from '../../models';
// import { getUserData, validateJwt } from '../../utils/wordpress';

type UserContextType = {
  user: User;
  isAuthenticated: boolean;
  loading: boolean;
  setUser: (user: User) => void;
  logoutUser: () => void;
  loginAuth0: () => void;
}

const UserContext = createContext<UserContextType>({
  user: null,
  isAuthenticated: false,
  loading: true,
  setUser: () => null,
  logoutUser: () => null,
  loginAuth0: () => null
});

const UserProvider = ({ children }: any) => {
  const { isAuthenticated, isLoading, loginWithRedirect, logout, getAccessTokenSilently, getAccessTokenWithPopup } = useAuth0();
  const auth0User = useAuth0().user;
  const [user, setUser] = useState<User>(null);
  const [loading, setLoading] = useState<boolean>(true);

  console.log('CURRENT USER: ', user, '\n\nAuth0 Authenticated: ', isAuthenticated, '\n\nAuth0 User: ', auth0User);

  useEffect(() => {
    (async () => {
      setLoading(true);
      if (auth0User) {
        let token = '';
        try {
          token = await getAccessTokenSilently();
        } catch (e) {
          try {
            token = await getAccessTokenWithPopup() || '';
          } catch {
            // do nothing
          }
        }

        setUser({
          token,
          id: auth0User.sub?.split('|')[1] || auth0User.sub,
          nickname: auth0User.nickname,
          username: auth0User.email,
          firstName: auth0User.given_name,
          lastName: auth0User.family_name,
          email: auth0User.email || '',
          roles: auth0User.userRoles || []
        });
      }

      setLoading(false);
    })();
  }, [auth0User, isLoading]);

  const loginAuth0 = () => {
    loginWithRedirect();

    // We may want to do allow the custom work in the future
    // loginWithRedirect({
    //   authorizationParams: {
    //     redirect_uri: '' // custom url here
    //   }
    // });
  };

  const logoutUser = () => {
    localStorage.removeItem('fullimpact.training:user');
    logout({
      logoutParams: {
        returnTo: `${window.location.origin}/schedule`
      }
    });
    setUser(null);
  };

  const superSetUser = (newUser: User) => {
    localStorage.setItem('fullimpact.training:user', JSON.stringify({ token: newUser?.token, email: newUser?.email }));
    setUser(newUser);
  };

  return (
    <UserContext.Provider value={{ user, isAuthenticated, setUser: superSetUser, loginAuth0, logoutUser, loading: loading || isLoading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
export default UserProvider;